/**
 * @summary
 * <blockquote>Permission verbs mapped to their string values</blockquote>
 **/
import { permissionOrder } from '../functions/permissionOrder';

export const PERMISSION_VERBS = {
  READ: permissionOrder[0],
  CREATE: permissionOrder[1],
  UPDATE: permissionOrder[2],
  DELETE: permissionOrder[3]
} as const; 